module.exports = __webpack_public_path__ + "static/media/Workplace.bae8f35b.svg";